import { Fragment } from 'react'

import {
  PanelHeader,
  PanelTitle,
  PanelDetailsGrid,
  Label,
  Value,
  PanelSection
} from 'components/attacks/details/AttackStyles'
import {
  getAttackConfiguration,
  getCommand,
  getTargetingStrategy,
  isContainerTargetType,
  isHostTargetType
} from 'components/attacks/utils/attack-configuration'
import Pill from 'components/common/Pill'
import theme from 'theme'
import { InfraAttack } from 'types/api/attacks/details/infra-attack'
import { TargetingStrategy } from 'types/api/attacks/details/targeting'
import { K8sAttack } from 'types/api/kubernetes/attacks'

const TagsDisplay: React.FC<{
  title: string
  multiValueMap?: {
    [key: string]: string[]
  }
}> = ({ multiValueMap, title }) => {
  if (!multiValueMap || Object.entries(multiValueMap).length === 0) {
    return null
  }

  return (
    <div
      css={{
        flex: 1,
        '&:not(:first-of-type)': {
          marginLeft: theme.space[5]
        }
      }}
    >
      <PanelHeader>
        <PanelTitle>{title}</PanelTitle>
      </PanelHeader>
      <PanelDetailsGrid css={{ alignItems: 'flex-start' }}>
        {Object.keys(multiValueMap).map((label) => (
          <Fragment key={label}>
            {/* TODO: Find a better way of aligning the line-height with the pill height */}
            <Label as="h5" color="dark" css={{ lineHeight: '30px' }}>
              {label}
            </Label>
            <Value>
              {multiValueMap[label].map((value) => {
                return (
                  <Pill
                    key={label + value}
                    showPointer
                    data-test-target-param-key={label}
                    data-test-target-param-value={value}
                    tooltip={`${label}:${value}`}
                  >
                    {value}
                  </Pill>
                )
              })}
            </Value>
          </Fragment>
        ))}
      </PanelDetailsGrid>
    </div>
  )
}

const TargetingSection: React.FC<{ targetingStrategy: TargetingStrategy }> = ({
  targetingStrategy
}) => {
  if (isHostTargetType(targetingStrategy)) {
    return (
      <TagsDisplay
        multiValueMap={targetingStrategy.multiSelectTags}
        title="Host Tags"
      />
    )
  } else if (isContainerTargetType(targetingStrategy)) {
    return (
      <TagsDisplay
        multiValueMap={targetingStrategy.multiSelectLabels}
        title="Container Labels"
      />
    )
  }

  return null
}

const TargetingPanel: React.FC<{ attack: InfraAttack | K8sAttack }> = ({
  attack
}) => {
  const attackConfig = getAttackConfiguration(attack)
  const command = getCommand(attackConfig)

  return (
    <PanelSection
      css={{
        display: 'flex',
        justifyContent: 'space-between'
      }}
    >
      {command.infraCommandArgs.trafficImpactMapping && (
        <TagsDisplay
          multiValueMap={
            command.infraCommandArgs.trafficImpactMapping.multiSelectTags
          }
          title="Network Tags"
        />
      )}
      <TargetingSection
        targetingStrategy={getTargetingStrategy(attackConfig)}
      />
    </PanelSection>
  )
}
export default TargetingPanel
